export default __webpack_public_path__ + "static/media/license_success.846e66dd.svg";